import {
  AnswersContainer,
  Collapse,
  Container,
  Heading,
  NavContainer,
  Question,
  SectionsContainer,
} from 'components/help/HelpSections/components';
import { Collapse as AntdCollapse, Spin } from 'antd';
import { ChevronDown, ChevronUp } from 'react-feather';

import BackToResultButton from 'components/common/BackToResultButton';
import FlexContainer from 'components/common/FlexContainer';
import { iconStyles } from 'styles/theme';
import useTranslation from 'hooks/use-translation';

export default function HelpSections(): JSX.Element {
  const translation = useTranslation();

  if (!translation) {
    return <Spin />;
  }

  return (
    <Container className='help-sections-container'>
      <NavContainer className='help-nav-container'>
        <BackToResultButton />
      </NavContainer>
      <SectionsContainer>
        {translation.help.sections.map((section) => (
          <FlexContainer key={section.key} gap={24}>
            <Heading className='help-section-heading'>{section.heading}</Heading>
            <Collapse
              className='help-section'
              key={section.key}
              accordion
              expandIconPosition='end'
              bordered={false}
              expandIcon={({ isActive }) =>
                isActive ? (
                  <ChevronUp size={24} color={iconStyles.colors.primary} />
                ) : (
                  <ChevronDown size={24} color={iconStyles.colors.primary} />
                )
              }
            >
              {section.content.map((content) => (
                <AntdCollapse.Panel
                  key={content.key}
                  header={<Question className='help-section-question'>{content.question}</Question>}
                >
                  <AnswersContainer className='help-section-answers-container' gap={16}>
                    {content.answer.map((answer) => (
                      <span className='help-section-answer' key={answer}>
                        {answer}
                      </span>
                    ))}
                  </AnswersContainer>
                </AntdCollapse.Panel>
              ))}
            </Collapse>
          </FlexContainer>
        ))}
      </SectionsContainer>
    </Container>
  );
}
